import { EauStatusesEnum } from '@thinknet-gmbh/platform-common';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

export const EAU_MODALS = {
  create: 'create',
  delete: 'delete',
  edit: 'edit',
};

export const EAU_STATUSES_STYLES = {
  [EauStatusesEnum.open]: {
    background: PLATFORM_THEME_COLORS.tone.lightBlue,
    fontColor: PLATFORM_THEME_COLORS.allowedColorsToUse.blue.normal,
  },
  [EauStatusesEnum.inprogress]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
  [EauStatusesEnum.rejected]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
  [EauStatusesEnum.accepted]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
};
